<section class="section">
    <div class="container">
        <div class="row g-lg-5">
            <div class="col-lg-6">
                <div class="section-header">
                    <div class="header-start">
                        <h2 class="title">Mobility without Breaking the Bank</h2>
                    </div>
                </div>
                <p>mobileWISE SAAS enable you to cut down development cost drastically with Pre-build components.</p>
                <p> Various pricing models to best suit your needs.</p>

                <div class="buttons">
                    <button class="btn btn-lg btn-dark btn-with-icon rounded-pill px-4" (click)="scroll()">Get Started <mat-icon>trending_flat</mat-icon></button>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="img-container">
                    <img src="./assets/imgs/cost-effective.png" alt="Concept to Production in Just 3 Weeks"
                        class="img-fluid" loading="lazy">
                </div>
            </div>
        </div>

    </div>
</section>